export const DOCUMENT_STEP_VIEW = 'document_step_view' as const
export const DOCUMENT_STEP_COMPLETED = 'document_step_completed' as const
export const DOCUMENT_PDF_FIRST_SCROLL = 'document_pdf_first_scroll' as const
export const DOCUMENT_PDF_DEPTH_MILESTONE = 'document_pdf_depth_milestone' as const
export const DOCUMENT_STEP_FIRST_INTERACTION = 'document_step_first_interaction' as const
export const DOCUMENT_PDF_INTERACTION = 'document_pdf_interaction' as const
export const DOCUMENT_TAB_HIDDEN = 'document_tab_hidden' as const
export const DOCUMENT_TAB_VISIBLE = 'document_tab_visible' as const
export const DOCUMENT_USER_INACTIVE = 'document_user_inactive' as const
export const DOCUMENT_USER_ACTIVE = 'document_user_active' as const
export const DOCUMENT_REVIEW_STARTED = 'document_review_started' as const
export const DOCUMENT_REVIEW_COMPLETED = 'document_review_completed' as const
export const DOCUMENT_FORM_HISTORY = 'document_form_history' as const
